module.exports = __webpack_public_path__ + "img/control-1.50e94d1e.png";